<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'
  import bus from '@utils/bus'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        isSearchingCity: false,
        form: {
          city_id: '',
          address: '',
          description: ''
        },
        dependencies: {
          cities: []
        }
      }
    },
    validations: {
      form: {
        city_id: {required},
        address: {required},
        description: {required}
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('place', null, id)
          .then(response => {
            this.form = response
            this.$set(this.dependencies.cities, 0, response.city)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      } else {
        this.isLoadingData = false
        bus.$emit('hide-loader')
      }
    },
    methods: {
      onSearchCity (query) {
        this.dependencies.cities = []
        if (query !== '') {
          this.isSearchingCity = true
          let data = {
            query
          }
          restfulService.post('city', 'search', null, data)
            .then((response) => {
              this.dependencies.cities = {...this.dependencies.cities, ...response}
              this.isSearchingCity = false
            })
            .catch(e => {
              console.log(e)
            })
        }
      },
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        restfulService.save('place', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'place.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Locais"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados do Local</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     @submit.native.prevent>
                <el-form-item label="Cidade"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.city_id.$error }">
                    <el-select v-model="form.city_id"
                               clearable
                               filterable
                               remote
                               :remote-method="onSearchCity"
                               :loading="isSearchingCity"
                               placeholder="Digite o nome da cidade"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full">
                        <el-option
                                v-for="item in dependencies.cities"
                                :key="item.id"
                                :label="item.name + ' / ' + item.state.uf"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="el-form-item__error" v-if="$v.form.city_id.$error">
                        Esse campo é obrigatório
                    </div>
                </el-form-item>
                <el-form-item label="Endereço"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.address.$error }">
                    <el-input v-model="form.address"
                              @input="$v.form.address.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.address.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Descrição"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.description.$error }">
                    <el-input v-model="form.description"
                              @input="$v.form.description.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.description.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted">
                    </form-save-button>
                    <form-cancel-button route-name="place.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Form.vue?d62039cc